import enJson from '../lang/en';
import frJson from '../lang/fr';
import nlJson from '../lang/nl';

function digDeeper(result, object, prefix) {
  for (const key in object) { // eslint-disable-line
    if (typeof object[key] === 'string' || typeof object[key] === 'number') {
      result[`${prefix}.${key}`] = object[key]; // eslint-disable-line
    } else {
      digDeeper(result, object[key], `${prefix}.${key}`);
    }
  }
}

export default function messages(lang) {
  let imported = enJson;
  const result = {};

  switch (lang) {
    case 'en':
      imported = enJson;
      break;
    case 'fr':
      imported = frJson;
      break;
    case 'nl':
      imported = nlJson;
      break;
    default:
      imported = nlJson;
      break;
  }

  for (const key in imported) { // eslint-disable-line
    if (imported[key] && key !== 'default') {
      if (typeof imported[key] === 'string' || typeof imported[key] === 'number') {
        result[key] = imported[key];
      } else {
        digDeeper(result, imported[key], key);
      }
    }
  }

  return result;
}



// WEBPACK FOOTER //
// ./js/utils/intl-messages.js